import { MainContainer } from "./styles";

export const UPCList = (props) => {
    return (
      <MainContainer>
        <ul>
          {props.upcExisting.map((upc) => (
            <li key={upc}>{upc}</li>
          ))}
        </ul>
      </MainContainer>
    );
  };
  